import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ReportsService } from 'src/app/core/services/reports.service';
import { ReportTabBase } from '../report-tab.base';

/** "yyyy-MM-ddT00:00" / "yyyy-MM-ddT23:59" in local time, as the travel report endpoint expects. */
function toDayBoundary(inputDate: Date, time: '00:00' | '23:59'): string {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${time}`;
}

@Component({
    selector: 'app-travel-report',
    templateUrl: './travel-report.component.html',
    styleUrl: '../report-tab.scss',
})
export class TravelReportComponent extends ReportTabBase {
    private readonly reportsService = inject(ReportsService);

    readonly form = new FormGroup({
        dateFrom: new FormControl(),
        dateTo: new FormControl(),
    });

    reports: any[] = [];

    submit(): void {
        const { dateFrom, dateTo } = this.form.getRawValue();

        this.startLoading('Creating report');
        this.reportsService.fetchTravelReport(toDayBoundary(dateFrom, '00:00'), toDayBoundary(dateTo, '23:59')).subscribe({
            next: (value) => {
                this.reports = value['bookingList'];
                this.stopLoading();
            },
            error: (err) => {
                this.stopLoading();
                this.showError(err.error.message);
            },
        });
    }

    export(): void {
        this.exportTable('Travel_Insurance_Report');
    }
}
